/**
 * @generated SignedSource<<e0719badda28885f3d1ab99d24d67ea2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VoterPanelActionsDelegateButtonFragment$data = {
  readonly address: {
    readonly resolvedName: {
      readonly address: string;
    };
  };
  readonly liquidDelegationProxy: {
    readonly __typename: "LiquidDelegationProxy";
  } | null;
  readonly " $fragmentType": "VoterPanelActionsDelegateButtonFragment";
};
export type VoterPanelActionsDelegateButtonFragment$key = {
  readonly " $data"?: VoterPanelActionsDelegateButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"VoterPanelActionsDelegateButtonFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VoterPanelActionsDelegateButtonFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LiquidDelegationProxy",
      "kind": "LinkedField",
      "name": "liquidDelegationProxy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Address",
      "kind": "LinkedField",
      "name": "address",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ResolvedName",
          "kind": "LinkedField",
          "name": "resolvedName",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "address",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Delegate",
  "abstractKey": null
};

(node as any).hash = "1896ccbf97e12fb0ccdea025196503f5";

export default node;
